
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const SearchBar = ({ searchTerm, onSearchChange }: SearchBarProps) => {
  const { t } = useTranslations("students");
  
  return (
    <div className="relative w-full max-w-md">
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input 
        placeholder={t('studentRequests.searchPlaceholder')}
        value={searchTerm} 
        onChange={e => onSearchChange(e.target.value)} 
        className="pl-8 bg-white/80 border border-slate-100"
      />
    </div>
  );
};
